// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../../../rescript/lib/es6/belt_Option.js";

var _map = {"Default":"default","Error":"error","Inherit":"inherit","Primary":"primary","Secondary":"secondary","TextPrimary":"textPrimary","TextSecondary":"textSecondary","Disabled":"disabled"};

var _revMap = {"default":"Default","error":"Error","inherit":"Inherit","primary":"Primary","secondary":"Secondary","textPrimary":"TextPrimary","textSecondary":"TextSecondary","disabled":"Disabled"};

function colorToJs(param) {
  return _map[param];
}

function colorFromJs(param) {
  return _revMap[param];
}

var _map$1 = {"Default":"default","Inherit":"inherit","Small":"small","Large":"large"};

var _revMap$1 = {"default":"Default","inherit":"Inherit","small":"Small","large":"Large"};

function fontSizeToJs(param) {
  return _map$1[param];
}

function fontSizeFromJs(param) {
  return _revMap$1[param];
}

function Make(Icon) {
  var reactClass = Icon.reactClass;
  var IconBinding$Make = function (Props) {
    var color = Props.color;
    var className = Props.className;
    var fontSize = Props.fontSize;
    var nativeColor = Props.nativeColor;
    var titleAccess = Props.titleAccess;
    var viewBox = Props.viewBox;
    var tmp = {};
    if (className !== undefined) {
      tmp.className = className;
    }
    var tmp$1 = Belt_Option.map(color, colorToJs);
    if (tmp$1 !== undefined) {
      tmp.color = tmp$1;
    }
    var tmp$2 = Belt_Option.map(fontSize, fontSizeToJs);
    if (tmp$2 !== undefined) {
      tmp.fontSize = tmp$2;
    }
    if (nativeColor !== undefined) {
      tmp.nativeColor = nativeColor;
    }
    if (titleAccess !== undefined) {
      tmp.titleAccess = titleAccess;
    }
    if (viewBox !== undefined) {
      tmp.viewBox = viewBox;
    }
    return React.createElement(reactClass, tmp);
  };
  return {
          reactClass: reactClass,
          make: IconBinding$Make
        };
}

export {
  colorToJs ,
  colorFromJs ,
  fontSizeToJs ,
  fontSizeFromJs ,
  Make ,
  
}
/* react Not a pure module */
